import Tooltip from "@material-ui/core/Tooltip/Tooltip";

export const TMCTooltip = Tooltip;
